module.exports = __webpack_public_path__ + "static/media/ellipsis.cb42b7f9.svg";